(function () {
  const EVENT_NAME = 'cta_click';

  const TRACK_SELECTOR = [
    '[data-track-cta]',
    'button[type="submit"]',
    'input[type="submit"]',
    'a.button',
    'button.button',
    'input.button',
    'summary.button',
    '[role="button"].button',
    'a[class*="__button"]',
    'button[class*="__button"]',
    'input[class*="__button"]',
    'summary[class*="__button"]',
    '[role="button"][class*="__button"]',
    'a[class*="-button"]',
    'button[class*="-button"]',
    'input[class*="-button"]',
    'summary[class*="-button"]',
    '[role="button"][class*="-button"]',
    'a[class*="__cta"]',
    'button[class*="__cta"]',
    'input[class*="__cta"]',
    'summary[class*="__cta"]',
    '[role="button"][class*="__cta"]',
    'a[class*="-cta"]',
    'button[class*="-cta"]',
    'input[class*="-cta"]',
    'summary[class*="-cta"]',
    '[role="button"][class*="-cta"]',
    '.shopify-payment-button__button',
  ].join(',');

  const EXCLUDE_SELECTOR = [
    '[data-track-cta="false"]',
    '[data-cta-track="false"]',
    '.no-track-cta',
    '.js-no-track-cta',
    '.skip-to-content-link',
    '.slider-button',
    '.slideshow__autoplay',
    '.quantity__button',
    '.quantity-popover__info-button',
    '.field__button',
    '.reset__button',
    '.search__button',
    '.modal__close-button',
    '.button-close',
    '.share-button__button',
    '.share-button__close',
    '.share-button__copy',
    '.content-share-popover__trigger',
    '.content-share-popover__option',
    '.disclosure__button',
    '.localization-form__select',
    '.country-filter__reset-button',
    '.country-selector__close-button',
    '.facets__reset',
    '.active-facets__button',
    '.active-facets__button-remove',
    '.mobile-facets__close-button',
    '.button-show-more',
    '.product-popup-modal__button',
    '.product__xr-button',
    '.deferred-media__poster',
    '.deferred-media__poster-button',
    '.card__information-volume-pricing-note--button',
    '.mag-issues__orbit',
    '.mag-issue-carousel__orbit',
    '.audience-reviews__mobile-arrow',
  ].join(',');

  function sanitizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getElementText(element) {
    if (element.dataset.trackCtaLabel) return sanitizeText(element.dataset.trackCtaLabel);
    if (element.getAttribute('aria-label')) return sanitizeText(element.getAttribute('aria-label'));
    if (element.value) return sanitizeText(element.value);
    return sanitizeText(element.innerText || element.textContent);
  }

  function getElementUrl(element) {
    if (element.dataset.trackCtaUrl) return element.dataset.trackCtaUrl;
    if (element.href) return element.href;
    if (element.formAction) return element.formAction;

    const link = element.querySelector('a[href]');
    return link ? link.href : '';
  }

  function getSectionData(element) {
    const section = element.closest('[id^="shopify-section-"], [data-section-id], [data-section]');
    if (!section) return { section_id: '', section_name: '' };

    const rawId =
      section.dataset.sectionId ||
      section.dataset.section ||
      (section.id && section.id.replace(/^shopify-section-/, '')) ||
      '';
    const parts = rawId.split('__');

    return {
      section_id: rawId,
      section_name: parts.length > 1 ? parts.slice(1).join('__') : '',
    };
  }

  function getEventPayload(element) {
    const sectionData = getSectionData(element);
    const eventName = element.dataset.trackCtaEvent || EVENT_NAME;

    return {
      event: eventName,
      cta_text: getElementText(element),
      cta_id: element.dataset.trackCtaId || element.id || '',
      cta_name: element.getAttribute('name') || '',
      cta_url: getElementUrl(element),
      cta_tag: element.tagName.toLowerCase(),
      cta_classes: element.className && typeof element.className === 'string' ? element.className : '',
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
      section_id: sectionData.section_id,
      section_name: sectionData.section_name,
    };
  }

  function pushEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      const gtagPayload = Object.assign({}, payload);
      const eventName = gtagPayload.event;

      delete gtagPayload.event;
      window.gtag('event', eventName, Object.assign({ transport_type: 'beacon' }, gtagPayload));
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const element = event.target.closest(TRACK_SELECTOR);

      if (!element || !document.documentElement.contains(element)) return;
      if (element.closest(EXCLUDE_SELECTOR)) return;
      if (element.disabled || element.getAttribute('aria-disabled') === 'true') return;

      pushEvent(getEventPayload(element));
    },
    true
  );
})();
